import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -468px 0 }
  100% { background-position: 468px 0 }
`;

export const ContratosContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 40px;
  box-sizing: border-box;
  background-image: url("/textura.jpg");
  background-size: cover;
  background-attachment: fixed;
`;

export const ContentBox = styled.div`
  background: rgba(30, 30, 30, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  h2 {
    margin: 0;
    color: #e6aa3a;
    font-size: 28px;
  }
`;

export const HomeInitialContent = styled.div`
  margin-bottom: 40px;
`;

export const Boxes = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
`;

export const Box = styled.div`
  background: rgba(40, 40, 40, 0.8);
  border-radius: 8px;
  padding: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100px;
`;

export const BoxContent = styled.div``;

export const BoxTitle = styled.h4`
  margin: 0 0 10px 0;
  color: #fff;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 500;
  opacity: 0.8;
  letter-spacing: 1px;
`;

export const StatNumber = styled.span`
  color: #e6aa3a;
  font-size: 24px;
  font-weight: 700;
`;

export const LoadingSkeleton = styled.div`
  width: 100px;
  height: 24px;
  background: #2a2a2a;
  background-image: linear-gradient(
    to right,
    #2a2a2a 0%,
    #3a3a3a 20%,
    #2a2a2a 40%,
    #2a2a2a 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 104px;
  display: inline-block;
  position: relative;
  animation: ${shimmer} 1s linear infinite forwards;
  border-radius: 4px;
`;

export const ContractsTitle = styled.h2`
  margin: 0;
  color: #e6aa3a;
  font-size: 28px;
`;

export const SearchAreaContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
`;

export const FiltersRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: flex-end;
  @media (max-width: 900px) {
    flex-wrap: wrap;
  }
`;

export const SearchInputsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const SearchClient = styled.div`
  position: relative;
  .title {
    display: block;
    font-size: 14px;
    color: #fff;
    opacity: 0.8;
    margin-bottom: 8px;
    text-transform: uppercase;
  }
  .box {
    display: flex;
  }
  input {
    flex-grow: 1;
    height: 45px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.3);
    padding: 0 20px;
    color: #fff;
    border-radius: 6px;
    font-size: 16px;
    transition: all 0.2s ease-in-out;
    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }
    &:disabled {
      background: rgba(0, 0, 0, 0.5);
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
  button {
    width: 60px;
    height: 45px;
    border: none;
    background: #e6aa3a;
    color: #111;
    cursor: pointer;
    border-radius: 0 6px 6px 0;
    font-size: 18px;
    margin-left: -6px;
    &:hover {
      background: #ffc300;
    }
  }
  input:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export const FilterDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  h4 {
    margin: 0;
    font-size: 14px;
    color: #fff;
    opacity: 0.8;
    text-transform: uppercase;
  }
  select {
    height: 45px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.3);
    padding: 0 15px;
    color: #fff;
    border-radius: 6px;
    &:disabled {
      background: rgba(0, 0, 0, 0.5);
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    padding: 15px;
    text-align: left;
    white-space: nowrap;
  }
  thead tr {
    background-color: rgba(0, 0, 0, 0.2);
    border-bottom: 2px solid #e6aa3a;
  }
`;

export const TableHeader = styled.thead``;

export const TableRow = styled.tr`
  color: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.3s;
  cursor: pointer;
  &:hover {
    background-color: rgba(230, 170, 58, 0.1);
  }
`;

export const TableHeaderCell = styled.th`
  color: #fff;
  font-weight: 600;
`;

export const TableBody = styled.tbody``;

export const TableCell = styled.td``;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  gap: 15px;
  color: #fff;
`;

export const PaginationButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  padding: 8px 16px;
  font-weight: 600;
  cursor: pointer;
  &:hover:not(:disabled) {
    background: #e6aa3a;
    color: #111;
    border-color: #e6aa3a;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
